import { provideHttpClient, withInterceptorsFromDi, withFetch, HTTP_INTERCEPTORS } from '@angular/common/http';
import { enableProdMode, ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { BrowserModule, provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, PreloadAllModules, withPreloading } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { ProjectInterceptor } from '@core/interceptors/project.interceptor';
import { metaReducers, reducers } from '@core/redux';
import { AuthEffects } from '@core/redux/auth/auth.effects';
import { FilterEffects } from '@core/redux/filter/filter.effects';
import { InviteEffects } from '@core/redux/invite/invite.effects';
import { MessageEffects } from '@core/redux/message/message.effects';
import { ProjectEffects } from '@core/redux/project/project.effects';
import { StatusEffects } from '@core/redux/status/status.effects';
import { TagEffects } from '@core/redux/tag/tag.effects';
import { TaskEffects } from '@core/redux/task/task.effects';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { environment } from 'environments/environment';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';

import { MAIN_ROUTES } from './app.routes';
import { TokenInterceptor } from './auth/interceptors/token.interceptor';

if (environment.production) {
  enableProdMode();
}

const socketConfig: SocketIoConfig = environment.socket;

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideRouter(MAIN_ROUTES, withPreloading(PreloadAllModules)),
    provideStore(reducers, { metaReducers: metaReducers }),
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true, // If set to true, the connection is established within the Angular zone
    }),
    provideEffects([
      AuthEffects,
      InviteEffects,
      FilterEffects,
      MessageEffects,
      ProjectEffects,
      StatusEffects,
      TagEffects,
      TaskEffects,
    ]),
    importProvidersFrom([BrowserModule, BrowserAnimationsModule, SocketIoModule.forRoot(socketConfig)]),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProjectInterceptor,
      multi: true,
    },
    provideClientHydration(withHttpTransferCacheOptions({ includePostRequests: true })),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
